/**
 *
 * @typedef {Object} CharactersRange
 * @property {number} min
 * @property {number} max
 */

/**
 *
 * @typedef {Object} AllowedFileTypes
 * @property {string} value
 */

/**
 *
 * @typedef {Object} FileSizes
 * @property {string} min_value
 * @property {string} min_value_unit
 * @property {string} max_value
 * @property {string} max_value_unit
 */

/**
 *
 * @typedef {Object} FormProperties
 * @property {string} field_label
 * @property { "sect-title" | "input" | "number" | "file" | "checkbox" | "dropdown" | "radio"}  field_type
 * @property {CharactersRange} characters_range
 * @property {AllowedFileTypes[]} allowed_types
 * @property {FileSizes} file_size
 * @property {string} is_required
 * @property {Array<FormProperties>} field_items
 */

/**
 *
 * @typedef {Array<FormProperties>} IData
 */

/**
 *
 * @param {IData} data
 */
export const makeBuildSchema =
  (data) =>
  (schema = {}) => {
    let $schema = { ...schema };

    data.forEach((item, index) => {
      if (item.field_type !== "sect-title") {
        const name = item.field_label;
        let type = "string";
        let required = false;
        if (
          !item.field_items ||
          item.field_type === "checkbox" ||
          item.field_type === "radio" ||
          item.field_type === "dropdown"
        ) {
          if (item.field_type === "number") {
            type = "number";
          }
          if (item.field_label.includes("email")) {
            type = "email";
          }
          if (item.is_required === "true") {
            required = true;
          }
          $schema[name] = { type, required };
          if (item.field_type === "file") {
            let allowedTypes = item.allowed_types;
              if (item.allowed_types && typeof item.allowed_types === 'string') {
                allowedTypes = JSON.parse(item.allowed_types);
              }
            $schema[name] = {
              type: "file",
              required,
              allowedTypes:
              item?.allowed_types &&
              allowedTypes?.map((item) => item.value).join(","),
              file_size: item.file_size && { ...item.file_size },
            };
          }
        } else {
          // handle for if there is field_items
          const buildSchema = makeBuildSchema(item.field_items);
          const sch = buildSchema($schema);
          $schema = { ...$schema, ...sch };
        }
      }
    });

    return { ...$schema };
  };

/**
 *
 * @param {IData} data
 */
export const makeSchemaV2Old =
  (data) =>
  (schema = {}) => {
    let $schema = { ...schema };
    try {
      if(typeof data === 'string'){
        data = JSON.parse(data)
      }
      data.forEach((item, index) => {
        if (item.field_type !== "sect-title") {
          const name = item.field_label;
          let type = "string";
          let required = false;
          if (
            !item.field_items ||
            item.field_type === "checkbox" ||
            item.field_type === "radio" ||
            item.field_type === "dropdown"
          ) {
            if (item.field_type === "number") {
              type = "number";
            }
            if (item?.field_label?.includes("email_address")) {
              type = "email";
            }
            if (item.is_required === "true") {
              required = true;
            }
            $schema[name] = { type, required };
            if (item.field_type === "file") {
              let allowedTypes = item.allowed_types;
              let fileSize = item?.file_size;
              if (item.allowed_types && typeof item.allowed_types === 'string') {
                allowedTypes = JSON.parse(item.allowed_types);
              }
              if (item?.file_size && typeof item.file_size === 'string') {
                fileSize = JSON.parse(item.file_size);
              }
              if (item?.file_size && typeof item.file_size === 'string') {
                fileSize = JSON.parse(item.file_size);
              }
              $schema[name] = {
                type: "file",
                required,
                allowedTypes:
                  item?.allowed_types &&
                  allowedTypes?.map((item) => item.value).join(","),
                file_size: fileSize,
                file_size: fileSize,
              };
            }
          } else {
            // handle for if there is field_items
            const buildSchema = makeSchemaV2(item.field_items);
            const sch = buildSchema();
            let obj = {
              [item.field_type]: {
                fields: {
                  ...sch,
                },
                name: item.field_label,
                type: item.field_type,
                required: item.is_required === "true",
              },
            };
            $schema = { ...$schema, ...obj };
          }
        }
      });
      return $schema;
    } catch (error) {
      console.log(error);
    }
  };
/**
 *
 * @param {IData} data
 */
export const makeSchemaV2 =
  (data) =>
  (schema = {}) => {
    let $schema = { ...schema };
    try {
      if(typeof data === 'string'){
        data = JSON.parse(data)
      }
      data.forEach((item, index) => {
        if (item.field_type !== "sect-title") {
          const name = item.field_label;
          let type = "string";
          let required = false;
          if (
            !item.field_items ||
            item.field_type === "checkbox" ||
            item.field_type === "radio" ||
            item.field_type === "dropdown"
          ) {
            if (item.field_type === "number") {
              type = "number";
            }
            if (item?.field_label?.includes("email_address")) {
              type = "email";
            }
            if (item.is_required === "true") {
              required = true;
            }
            $schema[name] = { type, required };
            if (item.field_type === "file") {
              let allowedTypes = [];
              let fileSize = item?.file_size;
              if (item.allowed_types && typeof item.allowed_types === 'string') {
                allowedTypes = JSON.parse(item.allowed_types);
              }
              if (item?.file_size && typeof item.file_size === 'string') {
                fileSize = JSON.parse(item.file_size);
              }
              $schema[name] = {
                type: "file",
                required,
                allowedTypes:
                  item?.allowed_types &&
                  allowedTypes?.map((item) => item.value).join(","),
                file_size: fileSize,
              };
            }
          } else {
            // handle for if there is field_items
            const buildSchema = makeSchemaV2(item.field_items);
            const sch = buildSchema();
            
            let obj = {
              [item.field_type]: {
                fields: {
                  ...sch,
                },
                name: item.field_label,
                type: item.field_type,
                required: item.is_required === "true",
              },
            };
            $schema = { ...$schema, ...obj };
          }
        }
      });
      return $schema;
    } catch (error) {
      console.log(error);
    }
  };
/**
 *
 * @param {IData} data
 */
export const makeSchemaV3 =
  (data) =>
  (schema = {}) => {
    let $schema = { ...schema };
    try {
      if(typeof data === 'string'){
        data = JSON.parse(data)
      }
      data.forEach((item, index) => {
        if (item.field_type !== "sect-title") {
          const name = item.field_type;
          let type = "string";
          let required = false;
          if (
            !item.field_items ||
            item.field_type === "checkbox" ||
            item.field_type === "radio" ||
            item.field_type === "dropdown"
          ) {
            if (item.field_type === "number") {
              type = "number";
            }
            if (item?.field_label?.includes("email_address")) {
              type = "email";
            }
            if (item.is_required === "true") {
              required = true;
            }
            $schema[name] = { type, required };
            if (item.field_type === "file") {
              let allowedTypes = [];
              let fileSize = item?.file_size;
              if (item.allowed_types && typeof item.allowed_types === 'string') {
                allowedTypes = JSON.parse(item.allowed_types);
              }
              if (item?.file_size && typeof item.file_size === 'string') {
                fileSize = JSON.parse(item.file_size);
              }
              $schema[name] = {
                type: "file",
                required,
                allowedTypes:
                  item?.allowed_types &&
                  allowedTypes?.map((item) => item.value).join(","),
                file_size: fileSize,
              };
            }
          } else {
            // handle for if there is field_items
            const buildSchema = makeSchemaV2(item.field_items);
            const sch = buildSchema();

            let obj = {
              [item.field_label]: {
                fields: {
                  ...sch,
                },
                name: item.field_label,
                type: item.field_type,
                required: item.is_required === "true",
              },
            };
            $schema = { ...$schema, ...obj };
          }
        }
      });
      return $schema;
    } catch (error) {
      console.log(error);
    }
  };
